<i18n>
{
	"no": {
		"edipartName": "Edipart",
		"messageFormat": "Format",
		"messagetype": "Type",
		"transportMethod": "Overføringsmetode",
		"recipient": "Mottaker",
		"sender": "Avsender",
		"serviceCodes": "Service koder",
		"serviceCode_internalCode": "Intern kode",
		"serviceCode_externalCode": "Ekstern kode"
	},
	"en": {
		"edipartName": "Edipart",
		"messageFormat": "Format",
		"messageType": "Type",
		"transportMethod": "Transportmethod",
		"recipient": "Recipient",
		"sender": "Sender",
		"serviceCodes": "Service codes",
		"serviceCode_internalCode": "Internal code",
		"serviceCode_externalCode": "External code"
	}
}

</i18n>
<template>
	<div v-if="edipart" class="vendor-edi-information">
		<t-text-input :label="$t('edipartName')" :value="edipart.name" disabled/>
		<t-text-input :label="$t('sender')" :value="edipart.outboundSetup.sender"  disabled/>
		<t-text-input :label="$t('recipient')" :value="edipart.outboundSetup.recipient" disabled/>
		<t-text-input :label="$t('Transportmethod')" :value="edipart.outboundSetup.transportMethod" disabled/>
		<t-text-input
			style="grid-column: span 2 / 4"
			:label="$t('Transportmethod')"
			:value="edipart.outboundSetup.endpoint"
			disabled
		/>

		<t-select
			:label="$t('serviceCodes')"
			:disabled="edipart.outboundSetup.serviceCodes.length === 0"
			:selectedItem="getPredifinedServiceCode()"
			:items="serviceCodes"
			@change="setServiceCode($event)"
		>
			<template v-slot:displayedValue>
				{{getServiceCodeDisplayValue}}
			</template>

			<template v-slot:optionItemValue="slotProps">
				{{slotProps.item.internalCode + ` (${slotProps.item.externalCode})`}}
			</template>
		</t-select>

		<t-text-input :label="$t('serviceCode_internalCode')" :value="getServiceCode('internalCode')" disabled/>
		<t-text-input :label="$t('serviceCode_externalCode')" :value="getServiceCode('externalCode')" disabled/>
	</div>
</template>

<script>

import getEdipartDetailsRequest from '../loadPlanningList/modals/edi/getEdipartDetailsRequest';

export default {
	props: {
		vendor: Object
	},

	data() {
		return {
			edipart : null,
			serviceCode: null,
			serviceCodes: [{ internalCode: null, externalCode: null }]
		};
	},

	computed: {
		getServiceCodeDisplayValue() {
			if (this.serviceCode && this.serviceCode.internalCode)
				return `${this.serviceCode.internalCode  } (${this.serviceCode.externalCode})`;
			else if (this.serviceCode && !this.serviceCode.internalCode)
				return '';
			return '';
		},
	},

	async created() {
		await this.getEdipartDetails();
	},

	methods: {
		async getEdipartDetails() {
			this.edipart = await getEdipartDetailsRequest(this.vendor.edipartId);
			this.serviceCodes = this.serviceCodes.concat(this.edipart.outboundSetup.serviceCodes);
		},
		setServiceCode(serviceCode) {
			this.serviceCode = serviceCode;
			this.vendor.serviceCode = serviceCode;
		},

		getPredifinedServiceCode() {
			if (this.vendor.serviceCode)
				this.serviceCode = this.serviceCodes.find(x => x.internalCode === this.vendor.serviceCode.internalCode);
			else
				this.serviceCode = this.serviceCodes[0];
			return this.serviceCode;
		},
		getServiceCode(property) {
			if (!this.serviceCode)
				return '';
			return this.serviceCode[property];
		}
	}
};
</script>

<style lang="scss" scoped>

.vendor-edi{
	height: 400px;
}

.vendor-edi-information{
	display:grid;
	grid-template-columns: repeat(3, minmax(150px, 1fr));
	column-gap: 5px;
	row-gap: 5px;
}
</style>